import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DocumentUploader from '../../components/DocumentUploader';
import VehicleLayout from '../../components/VehicleLayout';
import { useAxios } from '../../utils/hook/useAxios';
function VehiculeSettings() {
  const axios = useAxios();
  const [voitures, setVoitures] = useState([]);
  const userData = JSON.parse(window.localStorage.getItem('me'));
  const { vehiculeId, mois } = useParams();

  const [CertificatImmatriculationDoc, setCertificatImmatriculationDoc] = useState(null);
  const [CertificatImmatriculation, setCertificatImmatriculation] = useState(null);
  const [AssuranceDoc, setAssuranceDoc] = useState(null);
  const [Assurance, setAssurance] = useState(null);

  const [ControleTechniqueDoc, setControleTechniqueDoc] = useState(null);
  const [ControleTechnique, setControleTechnique] = useState(null);

  useEffect(() => {
    let fetchReviews = async () => {
      let datavehicule = window.localStorage.getItem('VehicleStorage');
      const response = await axios.get('/vehicles/searchbyid/' + vehiculeId);
      if (response.data) {
        window.localStorage.setItem('VehicleStorage', JSON.stringify(response.data));
      }
    };
    fetchReviews();
  }, []);

  // useEffect(() => {
  //   let fetchReviews = async () => {
  //     try {
  //       const response = await axios.put(`/vehicles/` + vehiculeId, {
  //         CertificatImmatriculation: CertificatImmatriculation == 1 ? 1 : 0,
  //         Assurance: Assurance == 1 ? 1 : 0,

  //         ControleTechnique: ControleTechnique == 1 ? 1 : 0,

  //         CertificatImmatriculationDoc: CertificatImmatriculationDoc,
  //         AssuranceDoc: AssuranceDoc,
  //         ControleTechniqueDoc: ControleTechniqueDoc,
  //       });
  //       if (response.data) {
  //       }
  //     } catch (error) {
  //       console.error("Erreur lors de la requête Axios :", error);
  //     }
  //   };
  //   fetchReviews();
  // }, [
  //   ControleTechnique,
  //   Assurance,
  //   CertificatImmatriculationDoc,
  //   CertificatImmatriculation,

  //   AssuranceDoc,
  //   ControleTechniqueDoc,
  //   ControleTechnique,
  // ]);

  useEffect(() => {
    const fetchVehicle = async () => {
      const response = await axios.get('/vehicles/searchbyid/' + vehiculeId);
      if (response.data) {
        const v = response.data;
        setCertificatImmatriculationDoc(v.CertificatImmatriculationDoc);
        setAssuranceDoc(v.AssuranceDoc);
        setControleTechniqueDoc(v.ControleTechniqueDoc);
      }
    };
    fetchVehicle();
  }, [vehiculeId]);

  const uploadToCloudinary = async (file, setter) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'r6s4af83');

    const response = await fetch('https://api.cloudinary.com/v1_1/dtrkcpsky/auto/upload', {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();
    setter(data.secure_url);
  };

  const handleSaveDocs = async () => {
    try {
      await axios.put(`/vehicles/${vehiculeId}`, {
        CertificatImmatriculationDoc,
        AssuranceDoc,
        ControleTechniqueDoc,
      });
      toast.success('Documents enregistrés avec succès');
    } catch {
      toast.error("Erreur lors de l'enregistrement");
    }
  };

  const docs = [
    {
      label: "Certificat d'immatriculation (Carte grise)",
      icon: 'bi-card-text',
      url: CertificatImmatriculationDoc,
      onUpload: (e) => uploadToCloudinary(e.target.files[0], setCertificatImmatriculationDoc),
      onDelete: () => {
        setCertificatImmatriculationDoc(null);
      },
    },
    {
      label: 'Assurance du véhicule',
      icon: 'bi-shield-check',
      url: AssuranceDoc,
      onUpload: (e) => uploadToCloudinary(e.target.files[0], setAssuranceDoc),
      onDelete: () => {
        setAssuranceDoc(null);
      },
    },
    {
      label: 'Contrôle technique',
      icon: 'bi-clipboard2-check',
      url: ControleTechniqueDoc,
      onUpload: (e) => uploadToCloudinary(e.target.files[0], setControleTechniqueDoc),
      onDelete: () => {
        setControleTechniqueDoc(null);
      },
    },
  ];

  const completedCount = docs.filter((d) => d.url).length;

  return (
    <VehicleLayout vehicleId={vehiculeId} pageTitle="Paramètres">
      <ToastContainer />
      <div className="col-12 col-lg-8 mx-auto">
        {/* En-tête */}
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div>
            <h4 className="fw-bold mb-1">
              <i className="bi bi-folder2-open me-2 text-primary"></i>Documents du véhicule
            </h4>
            <p className="text-muted small mb-0">
              Ces documents sont requis pour que votre annonce soit validée.
            </p>
          </div>
          <span
            className={`badge fs-6 ${completedCount === docs.length ? 'bg-success' : 'bg-warning text-dark'}`}
          >
            {completedCount}/{docs.length}
          </span>
        </div>

        {/* Barre de progression */}
        <div className="progress mb-4" style={{ height: 6 }}>
          <div
            className={`progress-bar ${completedCount === docs.length ? 'bg-success' : 'bg-warning'}`}
            style={{ width: `${(completedCount / docs.length) * 100}%` }}
          />
        </div>

        {/* Liste documents */}
        {docs.map((doc) => (
          <DocumentUploader
            key={doc.label}
            label={doc.label}
            docUrl={doc.url}
            onUpload={doc.onUpload}
            onDelete={doc.url ? doc.onDelete : undefined}
          />
        ))}

        <button className="btn btn-primary w-100 mt-2" onClick={handleSaveDocs}>
          <i className="bi bi-floppy me-2"></i>Enregistrer les documents
        </button>
      </div>
    </VehicleLayout>
  );
}

export default VehiculeSettings;
